import { Controller } from "@hotwired/stimulus"

export default class EventDispatcherController extends Controller {
  static values = {
    name: String,
    data: Object,
    dispatchOnConnect: Boolean,
  }

  connect() {
    if (this.dispatchOnConnectValue) {
      this.dispatchEvent({
        params: { name: this.nameValue, data: this.dataValue },
      })
    }
  }

  dispatchEventOnSuccess(event) {
    if (event.detail.success) {
      this.dispatchEvent(event)
    }
  }

  dispatchEvent({ params: { name, data } }) {
    const eventName = name || this.nameValue
    const eventData = data || this.dataValue

    this.dispatch(eventName, { detail: eventData })
  }

  click(event) {
    if (this.#isSimulatedKeydownEvent(event)) {
      return
    }

    this.element.click()
  }

  #isSimulatedKeydownEvent(event) {
    return event.type === "keydown" && !(event instanceof KeyboardEvent)
  }
}
